
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-role-request-container',
    imports: [ RouterModule],
    templateUrl: './role-request-container.component.html',
    styleUrl: './role-request-container.component.css'
})
export class RoleRequestContainerComponent {

}
